<template>
    <section class="index-planning" style="min-height: 800px;">
    <!-- <div style="height:calc(100% - 10px);width:calc(100% - 10px);margin:auto;"> -->
        <WaitingBlock v-if="isLoadingDayTemplates || isLoadingClocks || isLoadingBoxes"></WaitingBlock>
        <PlanningStuckedCard v-else-if="(dtList==null || dtList.count == 0) && (clockList==null || clockList.count == 0) && (boxList == null || boxList.count==0)" :hasBox="boxList !=null && boxList.count > 0" :hasClock="clockList !=null && clockList.count > 0"/>
        <FullCalendar ref="calendar" v-else :date="planningMonth" :scheduledData="scheduledData"></FullCalendar>
    </section>
</template>

<script>
    import WaitingBlock from'@/components/common/WaitingBlock.vue';
    import PlanningStuckedCard from './PlanningStuckedCard.vue';
    import { mapState } from 'vuex';
    import FullCalendar from "./FullCalendar";
    import { HTTP } from "@/utils/http";
    import Apis from "@/apis";
    import EventBus from '@/eventbus';

    export default {
        name: 'PlanningIndex',
        components: {
            WaitingBlock, PlanningStuckedCard, FullCalendar
        },
        // created() { console.log("Creaded") },
        mounted() {
            // console.log("mounted");
            this.loadData();
            this.startPolling();
            EventBus.$on('calendarNeedUpdate', this.loadData);
        },
        beforeDestroy() {
            clearInterval(this.polling)
        },
        data() {
            return {
                activeDate: new Date(),
                scheduledData: null,
                polling: null
            }
        },
        computed: {
            ...mapState({
                isLoadingDayTemplates: state => state.loadingStates.isLoadingStationDayTemplates,
                isLoadingBoxes: state => state.loadingStates.isLoadingStationBoxes,
                isLoadingClocks: state => state.loadingStates.isLoadingStationClocks,
                dtList: state => state.stationDayTemplates,
                clockList: state => state.stationClocks,
                boxList: state => state.stationBoxes,
                planningMonth: state => state.planningMonth,
            })
        },
        methods: {
            startPolling() {
                this.polling = setInterval(this.loadData, 10000);
            },
            async loadData() {
                try {
                    var response = await HTTP.get(Apis.planning.list, {
                        params: { stationUid: this.$route.params.stationUid },
                    });

                    const dataReformated = response.data.dataItem.map(e => ({
                        ...e,
                        date: e.date.split('T')[0]
                    }))
                    this.scheduledData = dataReformated;
                } catch (e) {
                }

            }
        }
    };
</script>

<style lang="scss" scoped>
    .index-planning {
        //margin: -15px;
        width: 100%;
        height: 100%;
        // overflow: hidden;
    }
</style>

<style>
    .m-portlet.full-height .m-portlet__body {
        padding: 0;
    }

    a.nav-month {
        display: inline-block;
        padding: 5px 15px;
        line-height: 30px;
        color: #d2d2d2;
    }

        a.nav-month i {
            font-size: 1.3em;
            color: #d2d2d2;
        }

            a.nav-month:hover, a.nav-month i:hover {
                color: #292C33;
            }
</style>
